import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 3.36 3.36',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Camada_2" data-name="Camada 2">
      <g id="Layer_2" data-name="Layer 2">
        <path
          fill={fill}
          d="M1.68,3.36A1.68,1.68,0,1,1,3.36,1.68,1.68,1.68,0,0,1,1.68,3.36Zm0-3.24A1.56,1.56,0,1,0,3.24,1.68,1.56,1.56,0,0,0,1.68.12Z"
        />
        <path
          fill={fill}
          d="M1.08,2.35a.05.05,0,0,1,0,0,.06.06,0,0,1,0-.09L2.24,1a.06.06,0,0,1,.09,0,.06.06,0,0,1,0,.08L1.12,2.33Z"
        />
        <path
          fill={fill}
          d="M2.28,2.35l0,0L1,1.12A0,0,0,0,1,1,1a0,0,0,0,1,.08,0l1.21,1.2a.08.08,0,0,1,0,.09Z"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
